var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column flex-fill" },
    [
      _c(
        "form",
        {
          attrs: { autocomplete: "off", "data-vv-scope": "form" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSave.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.disabled || _vm.saving,
                      id: "input-service-type",
                      name: "service-type",
                      label: "label",
                      filterable: true,
                      options: _vm.serviceTypes,
                      reduce: (option) => option.name,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("service-type") },
                      ],
                      error: _vm.fnFirstError("service-type"),
                    },
                    model: {
                      value: _vm.form.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type", $$v)
                      },
                      expression: "form.type",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.serviceTypePlaceholder) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-8" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:3",
                        expression: "'required|min:3'",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: !_vm.form.type || _vm.disabled || _vm.saving,
                      readonly: _vm.disabled,
                      type: "text",
                      id: "input-service-title",
                      name: "service-title",
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("service-title") },
                      ],
                      error: _vm.fnFirstError("service-title"),
                    },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.title",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.serviceTitlePlaceholder) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|url",
                        expression: "'required|url'",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: !_vm.form.type || _vm.disabled || _vm.saving,
                      readonly: _vm.disabled,
                      type: "url",
                      id: "input-service-url",
                      name: "service-url",
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("service-url") },
                      ],
                      error: _vm.fnFirstError("service-url"),
                    },
                    model: {
                      value: _vm.form.url,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "url",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.url",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.serviceUrlPlaceholder) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 btn-group", attrs: { role: "group" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-main text-nowrap",
                    attrs: { disabled: _vm.saving, type: "submit" },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.submitTitle) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.enableDelete
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-delete text-nowrap",
                        attrs: { disabled: _vm.saving, type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onDelete.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.deleteTitle) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-main text-nowrap",
                    attrs: { disabled: _vm.saving, type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onCancel.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.cancelTitle) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("modal-confirmation", {
        ref: "modalConfirmation",
        attrs: { title: "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }